// extracted by mini-css-extract-plugin
export default {"tableHeader":"LotInfoSmall_tableHeader__+nuFX"};